import { create } from 'zustand';
import { authApi } from '../api/auth';

export const ROLES = { owner: 3, admin: 2, editor: 1, viewer: 0 };

export function hasRole(userRole, requiredRole) {
  return (ROLES[userRole] ?? -1) >= (ROLES[requiredRole] ?? 99);
}

const useAuthStore = create((set, get) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  login: async (email, password) => {
    const { data } = await authApi.login(email, password);
    if (data.requiresTOTP) {
      return data; // { requiresTOTP: true, totpToken } — Login.jsx handles step 2
    }
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    set({ user: data.user, isAuthenticated: true, isLoading: false });
    return data;
  },

  verifyTOTP: async (totpToken, code) => {
    const { data } = await authApi.totpVerify(totpToken, code);
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    set({ user: data.user, isAuthenticated: true, isLoading: false });
    return data;
  },

  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    set({ user: null, isAuthenticated: false, isLoading: false });
  },

  checkAuth: async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      set({ isLoading: false });
      return;
    }
    try {
      const { data } = await authApi.me();
      set({ user: data, isAuthenticated: true, isLoading: false });
    } catch {
      get().logout();
    }
  }
}));

export default useAuthStore;
